"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryIteratorPath = exports.query = void 0;
exports.querySlugFunction = querySlugFunction;
var query = "\n  query {\n    allFishermanBusinessLocation {\n      nodes {\n        _id\n        name\n        street\n        city\n      }\n    }\n  }\n";
exports.query = query;
var queryIteratorPath = ['allFishermanBusinessLocation', 'nodes'];
exports.queryIteratorPath = queryIteratorPath;
function querySlugFunction(queryResult, queryResults) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    slugify = _ref.slugify;
  var name = queryResult.name,
    city = queryResult.city,
    street = queryResult.street;
  var slugifyOptions = {
    replaceSlashes: true
  };
  if (name) {
    return slugify(name, slugifyOptions);
  }
  var sameCities = queryResults.filter(function (_ref2) {
    var aCity = _ref2.city;
    return aCity === city;
  });
  if (sameCities.length <= 1) {
    return slugify(city, slugifyOptions);
  }
  return slugify("".concat(city, " ").concat(street), slugifyOptions);
}